import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './prism-icon2.js';

const prismIconButtonCss = ":host{display:inline-block;line-height:0;border-radius:var(--prism-border-radius-global-circle);--_size:var(--prism-icon-button-size, 2rem);--_color:var(--prism-icon-button-color, var(--prism-color-theme-base-contrast));--_background-color:var(--prism-icon-button-background-color, transparent)}:host([size=sm]){--_size:var(--prism-icon-button-size, 1.5rem);}:host([toggle][checked]:not([disabled])){--_color:var(--prism-icon-button-color, var(--prism-color-theme-accent-primary))}button{display:inline-grid;width:var(--_size);height:var(--_size);align-items:stretch;cursor:pointer;pointer-events:auto;padding:0;background:none;background-color:var(--_background-color);border:none;outline:none;border-radius:inherit;overflow:hidden;box-sizing:content-box}button>*{grid-area:1/1/-1/-1}.pwc-window-film{pointer-events:none;border-radius:inherit;overflow:inherit}.pwc-icon-container{padding:12.5%}.pwc-icon{color:var(--_color);width:100%;height:100%;--prism-icon-size:100%}button:hover>.pwc-window-film{background-color:var(--prism-color-theme-window-film-hover)}button:active>.pwc-window-film{background-color:var(--prism-color-theme-window-film-pressed)}button:focus-visible>.pwc-window-film{background-color:var(--prism-color-theme-window-film-focused)}button:disabled{pointer-events:none}button:disabled .pwc-icon{color:var(--prism-color-theme-disabled-contrast)}:host([pwc-button-group]){border-radius:0}:host([pwc-button-group]) button{border-inline-start:2px solid var(--prism-color-theme-outline)}:host([pwc-button-group__first]){border-start-start-radius:var(--prism-border-radius-global-pill);border-end-start-radius:var(--prism-border-radius-global-pill);}:host([pwc-button-group__first]) button{border-inline-start:none}:host([pwc-button-group__first]) prism-icon{translate:0.075rem}:host([pwc-button-group__last]){border-start-end-radius:var(--prism-border-radius-global-pill);border-end-end-radius:var(--prism-border-radius-global-pill);}:host([pwc-button-group__last]) prism-icon{translate:-0.075rem}";
const PrismIconButtonStyle0 = prismIconButtonCss;

const PrismIconButton = /*@__PURE__*/ proxyCustomElement(class PrismIconButton extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.valueChange = createEvent(this, "valueChange", 7);
        this.icon = undefined;
        this.toggle = false;
        this.checked = false;
        this.size = 'md';
        this.customIcon = undefined;
        this.disabled = false;
        this.label = undefined;
    }
    /**
     * When disabled, make sure no other handlers on this component get called, and stop propagating up the DOM tree.
     * This runs in the capture phase to make sure it's before any other handlers.
     */
    handleDisabledClick(event) {
        if (this.disabled) {
            event.stopImmediatePropagation();
        }
    }
    handleClick() {
        if (!this.disabled && this.toggle) {
            this.checked = !this.checked;
            this.valueChange.emit(this.checked);
        }
    }
    componentDidRender() {
        if (!this.label) {
            // eslint-disable-next-line no-console
            console.warn('[prism-icon-button] Please provide a label for the icon button to improve accessibility.');
        }
    }
    render() {
        return (h("button", { key: 'e8ffe46d1eab93006a3fe66f1b43a9bf97f8d553', disabled: this.disabled, "aria-label": this.label ? this.label : this.icon, role: this.toggle ? 'switch' : 'button', "aria-checked": this.toggle ? `${this.checked}` : null }, h("span", { key: '039cacd06cc6190a472b42396e3a0b7002a3300e', class: "pwc-window-film" }), h("span", { key: 'f836a56eebd92fe8715cb85f6ad07cc264a7db6e', class: "pwc-icon-container" }, h("prism-icon", { key: '79ea3c7000cd944a9494ff1d50a16da1c7e0eb13', icon: this.icon, customIcon: this.customIcon, class: "pwc-icon", "aria-hidden": "true" }))));
    }
    static get delegatesFocus() { return true; }
    static get style() { return PrismIconButtonStyle0; }
}, [17, "prism-icon-button", {
        "icon": [1],
        "toggle": [4],
        "checked": [1540],
        "size": [513],
        "customIcon": [1, "custom-icon"],
        "disabled": [516],
        "label": [1]
    }, [[2, "click", "handleDisabledClick"], [0, "click", "handleClick"]]]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["prism-icon-button", "prism-icon"];
    components.forEach(tagName => { switch (tagName) {
        case "prism-icon-button":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, PrismIconButton);
            }
            break;
        case "prism-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}

export { PrismIconButton as P, defineCustomElement as d };

